module.exports = {
    "queryUserImage": "/api/cps/queryUserImage", // 私有镜像列表查询
    "queryCommonImage": "/api/cps/queryCommonImage", //公共和定制镜像列表查询
    "deleteImage": "/api/cps/deleteImage", //删除镜像
    "describeImageSelects": "/api/cps/describeImageSelects", // 镜像筛选条件
    "exportImages": "/api/export/exportImages", // 导出镜像
};



// WEBPACK FOOTER //
// ./src/api/mirror/list/config.js